
<template>
  <div class="statInfo-content" >
	   <div class="statInfo-contentLeft">  
		    <div class="statInfo">
					   <div class="content">
						   <div class="content-item flexBC" @click="gotoPage(0)">
							   <div class="titleCon titleCon0 flexCC flexD">
								   <div class="iconImg flexCC">
									   <img src="../../../assets/home/top0.png" alt="" srcset="">
								   </div>
								   <div class="title">{{$t('homePage.Products')}}</div>
								    
							   </div>
							   <div class='content-data '>
								   <div class="dataItem">
									   <span class="desc">{{$t('homePage.Market')}}</span>
									   <span class="num">{{indexData.productsKind}}</span>
									   <Spin  fix v-if="indexData.productsKindLoding"></Spin>
								   </div>
							   </div>
						   </div>

						   <div class="content-item flexBC" @click="gotoPage(1)">
							   <div class="titleCon titleCon1 flexCC flexD">
								   <div class="iconImg flexCC">
									   <img src="../../../assets/home/top1.png" alt="" srcset="">
								   </div>
								   <div class="title">{{$t('homePage.User')}}</div>
							   </div>
							   <div class='content-data '>
								   <div class="dataItem">
									   <span class="desc">{{$t('homePage.Total')}}</span>
									   <span class="num">{{indexData.userCountAll}}</span>
									   <Spin  fix v-if="indexData.userCountAllLoding"></Spin>
								   </div>
								   <div class="dataItem">
									   <span class="desc">{{$t('homePage.Online')}}</span>
									   <span class="num">{{indexData.userCountOnline}}</span>
									    <Spin  fix v-if="indexData.userCountOnlineLoding"></Spin>
								   </div>
							   </div>
						   </div>

						   <div class="content-item flexBC" @click="gotoPage(2)">
							   <div class="titleCon titleCon2 flexCC flexD">
								   <div class="iconImg flexCC">
									   <img src="../../../assets/home/top2.png" alt="" srcset="">
								   </div>
								   <div class="title">{{$t('homePage.Device')}}</div>
							   </div>
							   <div class='content-data '>
								   <div class="dataItem">
									   <span class="desc">{{$t('homePage.Active')}}</span>
									   <span class="num">{{indexData.deviceAct}}</span>
									   <Spin  fix v-if="indexData.deviceActLoding"></Spin>
								   </div>
								   <div class="dataItem">
									   <span class="desc">{{$t('homePage.Online1')}}</span>
									   <span class="num">{{indexData.deviceOnline}}</span>
									   <Spin  fix v-if="indexData.deviceOnlineLoding"></Spin>
								   </div>
							   </div>
						   </div>

						   

						    <div class="content-item flexBC" @click="gotoPage(4)">
							   <div class="titleCon titleCon4 flexCC flexD">
								   <div class="iconImg flexCC">
									   <img src="../../../assets/home/top4.png" alt="" srcset="">
								   </div>
								   <div class="title">{{$t('homePage.Messages')}}</div>
							   </div>
							   <div class='content-data '>
								   <div class="dataItem">
									   <span class="desc">{{$t('homePage.New')}}</span>
									   <span class="num">{{indexData.message}}</span>
									   <Spin  fix v-if="indexData.messageLoding"></Spin>
								   </div>
							   </div>
						   </div>
						  <div class="content-item flexBC" @click="gotoPage(5)">
							   <div class="titleCon titleCon5 flexCC flexD">
								   <div class="iconImg flexCC">
									   <img src="../../../assets/home/top5.png" alt="" srcset="">
								   </div>
								   <div class="title">{{$t('homePage.Push')}}</div>
							   </div>
							   <div class='content-data '>
								   <div class="dataItem">
									   <span class="desc">{{$t('homePage.PushOfTotal')}}</span>
									   <span class="num">{{indexData.push}}</span>
									   <Spin  fix v-if="indexData.pushLoding"></Spin>
								   </div>
							   </div>
						   </div>
						  <div class="content-item flexBC" @click="gotoPage(6)">
							   <div class="titleCon titleCon6 flexCC flexD">
								   <div class="iconImg flexCC">
									   <img src="../../../assets/home/top6.png" alt="" srcset="">
								   </div>
								   <div class="title">{{$t('homePage.Log')}}</div>
							   </div>
							   <div class='content-data '>
								   <div class="dataItem">
									   <span class="desc">{{$t('homePage.LogToday')}}</span>
									   <span class="num">{{indexData.login}}</span>
									   <Spin  fix v-if="indexData.loginLoding"></Spin>
								   </div>
							   </div>
						   </div>
						   <div class="content-item content-itemVer flexBC" @click="gotoPage(3)">
							   <div class="titleCon titleCon3 flexCC flexD">
								   <div class="iconImg flexCC">
									   <img src="../../../assets/home/top3.png" alt="" srcset="">
								   </div>
								   <div class="title">{{$t('homePage.App')}}</div>
							   </div>
							   <div class='content-data '>
								   <div class="dataItem">
									   <span class="desc">{{$t('homePage.LastAndroidVer')}}</span>
									   <span class="num">{{indexData.andVer}}</span>
									   <Spin  fix v-if="indexData.andVerLoding"></Spin>
								   </div>
								   <div class="dataItem">
									   <span class="desc">{{$t('homePage.LastAppleVer')}}</span>
									   <span class="num">{{indexData.iosVer}}</span>
									   <Spin  fix v-if="indexData.iosVerLoding"></Spin>
								   </div>
							   </div>
						   </div>
						   <div class="content-item flexBC">
						   </div>
					   </div>
		    </div>
	   </div>
   </div>
</template>
<script>
import common from '@/common/common.js';
import moment from 'moment';
import { mapState } from 'vuex'
export default {
    name: "role2",
    components: {
        // ModelBox
    },
    data(){
        return{
            indexData:{
		    	productsKind:'',
		    	userCountAll:'',
		    	userCountOnline:'',
		    	deviceAct:'',
		    	deviceOnline:'',
		    	iosVer:'--',
		    	andVer:'--',
		    	message:'',
		    	push:'',
		    	login:'',
		    	productsKindLoding:true,
		    	userCountAllLoding:true,
		    	userCountOnlineLoding:true,
		    	deviceActLoding:true,
		    	deviceOnlineLoding:true,
		    	iosVerLoding:true,
		    	andVerLoding:true,
		    	messageLoding:true,
		    	pushLoding:true,
		    	loginLoding:true,
		    	
		    },
		    memuList1: [
					{
						id: 0,
						name: '平台首页',
						routeName:'home',
						children: [{
							id: 1,
							name: "平台首页",
							routeName:'home',
							route: "/"
						   }
						]
					},
					{
						id: 1,
						name: '产品管理',
						routeName:'Products',
						children: [{
							id: 1,
							name: "产品管理",
							routeName:'Products',
							route: "productManage"
						   }
						]
					},
					{
						id: 2,
						name: '产品页面',
						routeName:'Pages',
						children: [{
							id: 1,
							name: "产品页面",
							routeName:'Pages',
							route: "productPage"
						}]
					},
					{
						id: 3,
						name: '订单管理',
						routeName: "Order",
						children: [{
							id: 1,
							name: "订单管理",
							routeName:'Order',
							route: "orderManage"
						}]
					},
					{
						id: 4,
						name: '用户管理',
						route: "userManage",
						routeName: "User",
						children: [{
							id: 1,
							name: "用户管理",
							routeName: "User",
							route: "userManage"
						}]
					},
					{
						id: 5,
						name: '登录统计',
						route: "Login",
						routeName: "Login",
						children: [{
							id: 1,
							name: "登录统计",
							routeName: "Login",
							route: "loginStatistics"
						}]
                    },
					{
						id: 6,
						name: '设备管理',
						route: "Device",
						routeName: "Device",
						children: [{
							id: 1,
							name: "设备管理",
							routeName: "Device",
							route: "deviceManage"
						}]
                    },
                    {
						id: 7,
						name: '固件中心',
						route: "firmwareCenter",
						routeName: "firmwareCenter",
						children: [{
							id: 1,
							name: "固件管理",
							routeName: "firmwareVersion",
							route: "firmwareVersion"
						},
						{
							id: 2,
							name: "计划管理",
							routeName: "firmwarePlan",
							route: "firmwarePlan"
						},
						{
							id: 3,
							name: "下载历史",
							routeName: "firmwareDownload",
							route: "firmwareDownload"
						}]
                    },
                    {
						id: 8,
						name: '应用中心',
						route: "AppCenter",
						routeName: "AppCenter",
						children: [
                            {
                                id: 1,
                                name: "版本管理",
								routeName: "appVersion",
                                route: "appVersion"
                            },
                            {
                                id: 2,
                                name: "计划管理",
								routeName: "appPlan",
                                route: "appPlan"
                            },
							{
							id: 3,
							name: "下载历史",
							routeName: "appDownload",
							route: "appDownload"
						}
                        ]
                    },
                    {
						id: 9,
						name: '交易中心',
						route: "AccountCenter",
						routeName: "AccountCenter",
						children: [
                            {
                                id: 1,
                                name: "月度短信",
								routeName: "SMScost",
                                route: "SMScost"
                            },
                            {
                                id: 2,
                                name: "充值管理",
								routeName: "accountRecharge",
                                route: "accountRecharge"
                            },
                            {
                                id: 3,
                                name: "交易历史",
								routeName: "accountHistory",
                                route: "accountHistory"
                            }
                        ]
                    },
                    {
						id: 10,
						name: '反馈信息',
						route: "feedBack",
						routeName: "feedBack",
						children: [
                            {
                                id: 1,
                                name: "反馈信息",
								routeName:'feedBack',
                                route: "feedBack"
                            }
                        ]
                    },
                    {
						id: 11,
						name: '推送信息',
						route: "pushMessage",
						routeName:'pushMessage',
						children: [
                            {
                                id: 1,
                                name: "推送信息",
								routeName:'pushMessage',
                                route: "pushMessage"
                            },
                        ]
					},
					{
						id: 12,
						name: '配置管理',
						route: "setting",
						routeName:'setting',
						children: [
                            {
                                id: 1,
                                name: "设置",
								routeName:'setting',
                                route: "setting"
                            }
                        ]
					}
			],
			memuList3: [
				{
					id: 0,
					name: '平台首页',
					routeName:'home',
					icon:'icon-activeHome-copy-copy-copy',
					children: [{
						id: 1,
						name: "平台首页",
						routeName:'home',
						route: "/"
					   }
					]
				},
				{
					id: 1,
					name: '产品中心',
					routeName:'Products',
					icon:'icon-guanli',
					children: [{
						id: 1,
						name: "产品管理",
						routeName:'Products',
						route: "productManage"
					   },
				       {
				        	id: 2,
				        	name: "产品页面",
				        	routeName:'Pages',
				        	route: "productPage"
					   },
				    //    {
				    //     	id: 3,
				    //     	name: "基础型号",
				    //     	routeName:'BasicProduct',
				    //     	route: "basicProduct"
					//    },
				        {
				        	id: 4,
				        	name: "订单管理",
				        	routeName:'Order',
				        	route: "orderManage"
				        },
					]
				},
				{
					id: 2,
					name: '设备管理',
					route: "DeviceCenter",
					routeName: "DeviceCenter",
					icon:'icon-shebeiguanli',
					children: [{
						id: 1,
						name: "设备管理",
						routeName: "Device",
						route: "deviceManage"
					},
					// {
					// 	id: 2,
					// 	name: "设备定位",
					// 	routeName: "Location",
					// 	route: "deviceLocation"
					// }
					]
                },
				
				{
					id: 3,
					name: '用户管理',
					route: "userManage",
					icon:'icon-Management',
					routeName: "User",
					children: [{
						id: 1,
						name: "用户管理",
						routeName: "User",
						route: "userManage"
					}]
				},
				
                {
					id:4,
					name: '固件中心',
					route: "firmwareCenter",
					routeName: "firmwareCenter",
					icon:'icon-gujianguanli',
					children: [{
						id: 1,
						name: "固件管理",
						routeName: "firmwareVersion",
						route: "firmwareVersion"
					},
					{
						id: 2,
						name: "计划管理",
						routeName: "firmwarePlan",
						route: "firmwarePlan"
					},
					{
						id: 3,
						name: "下载历史",
						routeName: "firmwareDownload",
						route: "firmwareDownload"
					}]
                },
                {
					id: 5,
					name: '应用中心',
					route: "AppCenter",
					routeName: "AppCenter",
					icon:'icon-yingyong',
					children: [
                        {
                            id: 1,
                            name: "版本管理",
							routeName: "appVersion",
                            route: "appVersion"
                        },
                        {
                            id: 2,
                            name: "计划管理",
							routeName: "appPlan",
                            route: "appPlan"
                        },
						{
						id: 3,
						name: "下载历史",
						routeName: "appDownload",
						route: "appDownload"
					}
                    ]
                },
                {
					id: 6,
					name: '交易中心',
					route: "AccountCenter",
					routeName: "AccountCenter",
					icon:'icon-jiaoyizhongxin-01',
					children: [
                        {
                            id: 1,
                            name: "月度短信",
							routeName: "SMScost",
                            route: "SMScost"
                        },
                        {
                            id: 2,
                            name: "充值管理",
							routeName: "accountRecharge",
                            route: "accountRecharge"
                        },
                        {
                            id: 3,
                            name: "交易历史",
							routeName: "accountHistory",
                            route: "accountHistory"
                        }
                    ]
                },
				{
					id: 7,
					name: '登录统计',
					route: "Login",
					routeName: "Login",
					icon:'icon-gupiao',
					children: [{
						id: 1,
						name: "登录统计",
						routeName: "Login",
						route: "loginStatistics"
					}]
                },
				 {
					id: 8,
					name: '反馈信息',
					route: "feedBack",
					routeName: "feedBack",
					icon:'icon-fankui',
					children: [
                        {
                            id: 1,
                            name: "反馈信息",
							routeName:'feedBack',
                            route: "feedBack"
                        }
                    ]
                },
                {
					id: 9,
					name: '推送信息',
					route: "pushMessage",
					routeName:'pushMessage',
					icon:'icon-tuisong',
					children: [
                        {
                            id: 1,
                            name: "推送信息",
							routeName:'pushMessage',
                            route: "pushMessage"
                        },
                    ]
				},
				{
					id:10,
					name: '配置管理',
					route: "setting",
					routeName:'setting',
					icon:'icon-shezhi1',
					children: [
                        {
                            id: 1,
                            name: "设置",
							routeName:'setting',
                            route: "setting"
                        }
                    ]
				},

			],
		    routeList:[
		    	{id:1,name:'产品管理',sflag:'1-1',ssflag:'1-1'},
		    	{id:2,name:'用户',sflag:'4-1',ssflag:'3-1'},
		    	{id:3,name:'设备',sflag:'6-1',ssflag:'2-1'},
		    	{id:4,name:'app',sflag:'8-1',ssflag:'5-1'},
		    	{id:5,name:'消息',sflag:'10-1',ssflag:'8-1'},
		    	{id:6,name:'推送',sflag:'11-1',ssflag:'9-1'},
		    	{id:7,name:'登录日志',sflag:'5-1',ssflag:'7-1'}
	        ]
        }
    },
    computed:{
		 ...mapState(['local','uInfo','selectId','showChildrenSide']),
		 roleType(){
	        let res = '2'
	        if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        	res = this.$store.state.uInfo.roleType
	        }
	        return res
	    },
    },
    created() {
		this.getSide()
        this.getData();
		
    },
    watch: {
        showChildrenSide(newVal,oldVal){
            if(this.roleType==1){
		    	this.memuList = this.memuList3
		    }else if(this.roleType==2){
		    	this.memuList = this.memuList1
		    }
		},
    },
    methods: {
        gotoPage(num){
			if(this.roleType==1){
				this.selectMenu(this.routeList[num].ssflag)
			}else if(this.roleType==2){
				this.selectMenu(this.routeList[num].sflag)
			}
	  		
	    },
		getSide() {
			if(this.roleType==1){
				this.memuList = this.memuList3
			}else if(this.roleType==2){
				this.memuList = this.memuList1
			}
        },
	    selectMenu(name) {
            this.colorHome = "";
			if (this.$store.state.tabList.length >= 50) {
				common.msg("error", "标签最多只可添50个，请删除后再操作", () => {});
				return
			}
			// console.log('this.memuList',this.memuList)
			let menuItem = name.split('-')
			let offIndex1 = this.memuList.findIndex((mitem, index) => {
				return mitem.id == menuItem[0]
			})
			let offIndex2 = this.memuList[offIndex1].children.findIndex((mitem, index) => {
				return mitem.id == menuItem[1]
			})
			let fObj = this.memuList[offIndex1]
			let sObj = this.memuList[offIndex1].children[offIndex2]
			let itemObj = {
				activeId: name,
				fId: fObj.id,
				fTitle: fObj.name,
				sId: sObj.id,
				sTitle: sObj.name,
				routeName:sObj.routeName,
				routerUrl: sObj.route
			}
            // console.log('titemObj',itemObj)
           this.$store.commit('setSlideItem', itemObj)
           this.$router.push({ path: itemObj.routerUrl })  
		},
        async getData(){
		    let res1 =  await this.axios.post(this.config.urlArray.productsKind, {dealerId:this.selectId})
			common.ajaxMsg(res1.data,false,()=>{
			   this.indexData.productsKind = res1.data.data
               this.indexData.productsKindLoding = false
			},()=>{
			   this.indexData.productsKindLoding = false
			})


		    let res2 = await this.axios.post(this.config.urlArray.userCount, {dealerId:this.selectId})
			common.ajaxMsg(res2.data,false,()=>{
			   this.indexData.userCountAll = res2.data.data
			   this.indexData.userCountAllLoding = false
			},()=>{
			   this.indexData.userCountAllLoding = false
			})


		    let res3 = await this.axios.post(this.config.urlArray.devicesCount, {dealerId:this.selectId})

			common.ajaxMsg(res3.data,false,()=>{
			    this.indexData.deviceAct = res3.data.data.active
                this.indexData.deviceOnline = res3.data.data.masterDeviceCount
				this.indexData.deviceActLoding = false
				this.indexData.deviceOnlineLoding = false
			},()=>{
				this.indexData.deviceActLoding = false
				this.indexData.deviceOnlineLoding = false
			})


		    let res4 = await this.axios.post(this.config.urlArray.OnlineNumber, {dealerId:this.selectId})
			common.ajaxMsg(res4.data,false,()=>{
			   this.indexData.userCountOnline = res4.data.data
			   this.indexData.userCountOnlineLoding = false
			},()=>{
			   this.indexData.userCountOnlineLoding = false
			})
			

			

			let res7 = await this.axios.post(this.config.urlArray.newMessageNum, {dealerId:this.selectId})
			common.ajaxMsg(res7.data,false,()=>{
			     this.indexData.message = res7.data.data
				this.indexData.messageLoding = false
			},()=>{
				this.indexData.messageLoding = false
			})
		


			let res8 = await this.axios.post(this.config.urlArray.pushes, {dealerId:this.selectId})
			common.ajaxMsg(res8.data,false,()=>{
			    this.indexData.push = res8.data.data.count
				this.indexData.pushLoding = false
			},()=>{
			  this.indexData.pushLoding = false
			})
			if(res8 && res8.data.code==1){
                this.indexData.push = res8.data.data.count
				this.indexData.pushLoding = false
		    }
            

			let myDate  = new Date();
			let myflag = myDate.getFullYear()+'-'+(myDate.getMonth()+1)+'-'+myDate.getDate()+" 00:00:00";    
            let dataobj = {
				  
				    startDate:(new Date(myflag)).getTime(),
				    endDate:myDate.getTime(),
					dealerId:this.selectId
				    
			    }
			let res9 = await this.axios.post(this.config.urlArray.logCount, dataobj)

			common.ajaxMsg(res9.data,false,()=>{
			    this.indexData.login = res9.data.data.count || 0
				this.indexData.loginLoding = false
			},()=>{
			  
				this.indexData.loginLoding = false
			})


			let res5 = await this.axios.post(this.config.urlArray.apps,{os:1,dealerId:this.selectId})
			// let res5 = await this.axios.get('/apis/mng/app/dealer/10001/apps', {params:{os:1}})

			

			common.ajaxMsg(res5.data,false,()=>{
			    if(res5.data.data.length>0){
				   this.indexData.andVer = res5.data.data[0].version
			    }
				this.indexData.andVerLoding = false
			},()=>{
			   this.indexData.andVerLoding = false
			})

			let res6 = await this.axios.post(this.config.urlArray.apps, {os:2,dealerId:this.selectId})
			common.ajaxMsg(res6.data,false,()=>{
			   if(res6.data.data.length>0){
				   this.indexData.iosVer = res6.data.data[0].version
				  
			    }
				this.indexData.iosVerLoding = false
			},()=>{
			   this.indexData.iosVerLoding = false
			})

	    }
    }
}
</script>
<style lang="less" scoped>
.statInfo-content{
	display: flex;
	.statInfo-contentLeft{
				flex: 1;
				// margin-right: 20px;
				.content{
					flex-wrap: wrap;
					.content-item{
						// border-left: 1px solid #ECECEC;
						width: 23%;
						min-width: 356px;
						max-width: 23%;
						margin-right: 1%;
						margin-bottom: 22px;
						.title{
							justify-content: center;
							font-size:16px;
							font-weight:bold;
							color:#FFF;
							line-height:17px;
							// margin-bottom: 20px;
						}
					}
					.content-itemVer{
                        min-width: 436px;
					}
					.titleCon{
						flex-shrink: 0;
						width: 136px;
                        height: 130px;
                        background: #4ABAF0;
                        border-radius: 14px 0px 0px 14px;
						color: #FFF;
						font-size: 16px;
						font-weight: bold;
						font-family: Source Han Sans SC;
						text-align: center;
						.iconImg{
                            width: 60px;
							height: 60px;
							margin: 0 auto;
							img{
								width: 100%;
								height: auto;
							}
						}
					}
					.titleCon1{
						background: #F8D347;
					}
					.titleCon2{
						background: #57C8F2;
					}
					.titleCon3{
						background: #91CC75;
					}
					.titleCon4{
						background: #FF6C60;
					}
					.titleCon5{
						background: #6B8EFC;
					}
					.titleCon6{
						background: #FF9E5E;
					}
					.content-data{
						 background-color: #FFF;
						 flex-grow: 1;
						 border-radius: 0px 14px 14px 0px;
						 color: #4ABAF0;
						 height: 130px;
						 display: flex;
						 flex-direction: column;
						 justify-content: center;
						 padding-left: 30px;
						 min-width: 168px;
						 .dataItem{
							 margin-bottom: 28px;
							 position: relative;
							 &:nth-last-of-type(1){
								  margin-bottom: 0;
							 }
							 .num{
								 margin-left: 20px;
								 font-size: 20px;
								 font-weight: bold;
							 }
						 }
					 }
				}
				
	}
	.statInfo-contentRight{
		width:360px;
		background: #FFF;
		.content{
			// height: 100%;
			flex-wrap: wrap;
			>div{
				width:50%;
			}
		}
	} 
	.statInfo{
				margin-bottom: 20px;
				.content{
					padding: 30px 0 20px;
					display: flex;
					
				}
	}
}
</style>
